<template>
    <slot v-bind="{
        ...state,
        setForm,
    } "/>
</template>

<script setup>
import { onMounted, reactive } from 'vue';

const props = defineProps({
    gtmEvent: {
        type: String,
        default: null,
    },
    submittingMessage: {
        type: String,
        default: 'Signing you up…',
    },
    successMessage: {
        type: String,
        default: 'Thank you for signing up for the LA Phil email list.',
    },
    newUserMessage: {
        type: String,
        default: 'Thank you for joining our mailing list!',
    },
    existingUserMessage: {
        type: String,
        default: 'Thank you, you are already signed up.',
    },
    errorMessage: {
        type: String,
        default: 'Sorry an error occurred, please try again!',
    },
});

const state = reactive({
    isProcessing: false,
    message: null,
});

let form;

const setForm = element => {
    form = element;
}

onMounted(() => {
    form?.addEventListener('submit', event => {
        event.preventDefault();

        state.isProcessing = true;
        state.message = props.submittingMessage;

        fetch(event.target.action, { // eslint-disable-line
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                email: event.target.elements['email']?.value.trim(),
                customer_contact_point_purposes: event.target.elements['customer_contact_point_purposes']?.value.trim() ?? null,
            }),
        }).then(response => {
            return response.json();
        }).then(response => {
            if (response.data.error) {
                state.message = response.data.description;
            } else if (response.data && response.data.new_user) {
                state.message = props.newUserMessage;

                if (props.gtmEvent) {
                    window.dataLayer.push({
                        event: props.gtmEvent,
                    });
                }
            } else {
                state.message = props.existingUserMessage;
            }
        }).catch(error => {
            console.error('error submitting subscription', error);

            if (error.data && error.data.description) {
                state.message = error.data.description;
            } else {
                state.message = props.errorMessage;
            }
        }).finally(() => {
            state.isProcessing = false;
        });
    });
});
</script>
